/**
 * Available subscription tiers following Hormozi "less is more" principle.
 * Three tiers: Designer (solo), Professional (firms), Enterprise (teams).
 *
 * Naming note: the third tier's internal planId/env key is "studio"
 * (STRIPE_PRICE_STUDIO) and must NOT be renamed — it is wired to Stripe
 * price secrets. Its user-facing display name is "Enterprise".
 */
export const PLANS = [
  {
    id: "starter" as const,
    name: "Designer",
    monthlyPrice: 29,
    annualPrice: 290,
    description: "For solo architects",
    features: ["400 renders/month", "4K resolution", "Email support"],
    featured: false,
  },
  {
    id: "pro" as const,
    name: "Professional",
    monthlyPrice: 79,
    annualPrice: 790,
    description: "For architecture firms",
    features: ["1,500 renders/month", "Priority processing", "Priority support"],
    featured: true,
  },
  {
    // Internal planId key "studio" maps to the user-facing display name "Enterprise".
    id: "studio" as const,
    name: "Enterprise",
    monthlyPrice: 299,
    annualPrice: 2990,
    description: "For teams with volume",
    features: ["6,000 renders/month", "Team seats (5 users)", "Dedicated support"],
    featured: false,
  },
];

export type Plan = (typeof PLANS)[0];
export type PlanId = Plan["id"];

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};
